import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {StyleableButtonComponent} from './styleable-button.component';



@NgModule({
  declarations: [
    StyleableButtonComponent
  ],
  exports: [
    StyleableButtonComponent
  ],
  imports: [
    CommonModule
  ]
})
export class StyleableButtonModule { }
